import { Alert, Heading, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import type { AvtaleDto } from "@/api/generated";
import { formatDateString } from "@/utils/dateTimeUtils";

export const AvtaleUtloptAlert = ({ avtale }: { avtale: AvtaleDto }) => {
  const { t } = useTranslation();

  return (
    <Alert>
      <div className="flex flex-col gap-2">
        <Heading level={2} data-size="xs">
          {t("pages.avtaler.avbestilling.alert-utløpt-tittel")}
        </Heading>
        <Paragraph>
          {t("pages.avtaler.avbestilling.alert-utløpt-beskrivelse")}{" "}
          {formatDateString(avtale.activeToExclusive)}.
        </Paragraph>
      </div>
    </Alert>
  );
};
